// extracted by mini-css-extract-plugin
module.exports = {"root":"TagSelectLabel_root__3o8KJ","disabled":"TagSelectLabel_disabled__2Zld3","error":"TagSelectLabel_error__2uZuU"};